export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-24 md:pt-52 md:pb-32 overflow-hidden border-b border-white/5">
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B]/70 via-[#0B0B0B]/85 to-[#0B0B0B]" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        {eyebrow && <div className="section-eyebrow mb-6">{eyebrow}</div>}
        <h1 className="font-cinzel uppercase text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-neutral-300 text-base md:text-lg mt-8 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
